import { gql } from "@apollo/client";

export default gql`
    query couponAggregate($where: subscription_coupon_bool_exp) {
        couponAggregate: subscription_coupon_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`;
